import React from 'react';
import { langBasic } from '@language';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import BasicFormFilePhotoContainer from './basic_form_file_photo';
import { isEmpty } from 'lodash';
import Typography from '@material-ui/core/Typography';
import Field from '../simple/field';
import {configDiploma, configDiplomaEn} from "../../config/diploma";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    photoInput: {
        display: 'none',
    },
    photoLabel: {
        cursor: 'pointer',
    },
    alignRight: {
        textAlign: 'right',
    },
    addressBlock: {
        borderWidth: '1px',
        borderColor: '#c0c0c0',
        borderStyle: 'solid',
        borderRadius: '4px',
        margin: '8px',
        paddingLeft: '15px !important',
        paddingRight: '15px !important',
        paddingBottom: '15px !important',
        paddingTop: '0 !important',
    },
    addressLabel: {
        color: '#757575',
        backgroundColor: '#fff',
        position: 'relative',
        top: '-10px',
        left: '-5px',
        paddingLeft: '5px',
        paddingRight: '5px',
    },
    diplomaBlock: {
        borderWidth: '1px',
        borderColor: '#c0c0c0',
        borderStyle: 'solid',
        borderRadius: '4px',
        margin: '8px',
        paddingLeft: '15px !important',
        paddingRight: '15px !important',
        paddingBottom: '15px !important',
        paddingTop: '0 !important',
    },
    diplomaLabel: {
        color: '#757575',
        backgroundColor: '#fff',
        position: 'relative',
        top: '-10px',
        left: '-5px',
        paddingLeft: '5px',
        paddingRight: '5px',
    },
}));

export const BasicForm = ({profileBasic, mailingRegion, mailingTownType, digitalProfileSettings, onSave}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const [state, setValue] = React.useState({
        gender_id: Number(profileBasic.gender_id ? profileBasic.gender_id : 0),
        mailing_region_id: Number(profileBasic.mailing_region_id ? profileBasic.mailing_region_id : 0),
        mailing_town_type_id: Number(profileBasic.mailing_town_type_id ? profileBasic.mailing_town_type_id : 0),
        diploma_id: Number(profileBasic.diploma_id ? profileBasic.diploma_id : 0),
    });
    let refs = {};
    const save = () => {
        const data = {
            id: refs.id.value,
            first_name: refs.first_name.value,
            last_name : refs.last_name.value,
            middle_name : refs.middle_name.value,
            gender_id: refs.gender_id.value,
            custom_information: refs.custom_information.value,
            phone: refs.phone.value,
            snils: refs.snils.value,
            additional_phone: refs.additional_phone.value,
            mailing_address: refs.mailing_address.value,
            mailing_region_id: refs.mailing_region_id.value,
            mailing_town_type_id: refs.mailing_town_type_id.value,
            diploma_id: refs.diploma_id.value,
        };
        const fileIds = refs.getPhotoFileIdsFn();
        data.photo_file_id = !isEmpty(fileIds) && fileIds.hasOwnProperty('photo') ? fileIds.photo : null;
        data.scan_copy_snils_file_id = !isEmpty(fileIds) && fileIds.hasOwnProperty('scan_copy_snils') ? fileIds.scan_copy_snils : null;
        onSave(
            data,
            digitalProfileSettings.is_required_photo || digitalProfileSettings.is_required_scan_copy_snils
                ? refs.successSaveCallbackForFiles
                : undefined
        );
    };
    const handleChange = (e) => {
        const name = e.target.name;
        setValue({...state, [name]: Number(e.target.value)});
    };
    return (
        <React.Fragment>
            <input ref={input => refs.id = input} type="hidden" defaultValue={profileBasic.applicant_id}/>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={t('first_name')}
                        inputRef={input => refs.first_name = input}
                        defaultValue={profileBasic.first_name ? profileBasic.first_name : ''}
                        required/>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={t('last_name')}
                        inputRef={input => refs.last_name = input}
                        defaultValue={profileBasic.last_name? profileBasic.last_name: ''}
                        required/>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={t('middle_name')}
                        inputRef={input => refs.middle_name = input}
                        defaultValue={profileBasic.middle_name ? profileBasic.middle_name : ''}
                        />
                </Grid>

                <Grid item xs={12}>
                    <input type="hidden" ref={input => refs.gender_id = input} value={state.gender_id}/>
                    <FormControl component="fieldset" size="small" required>
                        <FormLabel component="legend">{t('gender')}</FormLabel>
                        <RadioGroup
                            aria-label="gender"
                            name="gender_id"
                            value={state.gender_id}
                            onChange={handleChange}>
                            <FormControlLabel value={1} control={<Radio
                                color="primary"
                            />} label={t('man')}/>
                            <FormControlLabel value={2} control={<Radio
                                color="primary"
                            />} label={t('female')}/>
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={t('email')}
                        defaultValue={profileBasic.email ? profileBasic.email : ''}
                        required
                        disabled />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={t('phone')}
                        inputRef={input => refs.phone = input}
                        defaultValue={profileBasic.phone ? profileBasic.phone : ''}
                        required/>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={t('additional_phone')}
                        inputRef={input => refs.additional_phone = input}
                        defaultValue={profileBasic.additional_phone ? profileBasic.additional_phone : ''}
                        />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={t('snils')}
                        inputRef={input => refs.snils = input}
                        defaultValue={profileBasic.snils ? profileBasic.snils : ''}
                        />
                </Grid>
                <Grid item xs={12} className={classes.addressBlock}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="caption" className={classes.addressLabel}>{t('address')}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <input type="hidden" ref={input => refs.mailing_region_id = input} value={state.mailing_region_id}/>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel id="mailing_region_id" required>
                                    {t('mailing_region_id')}
                                </InputLabel>
                                <Select
                                    labelId="mailing_region_id"
                                    label={t('mailing_region_id')}
                                    name="mailing_region_id"
                                    value={state.mailing_region_id}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="0">{t('not_selected')}</MenuItem>
                                    {mailingRegion.map(region => {
                                        return <MenuItem key={region.id} value={Number(region.id)}>
                                            {currentLang === 'en' ? region.value_en : region.value}
                                        </MenuItem>;
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <input
                                type="hidden"
                                ref={input => refs.mailing_town_type_id = input}
                                value={state.mailing_town_type_id}/>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel id="mailing_town_type_id" required>
                                    {t('mailing_town_type_id')}
                                </InputLabel>
                                <Select
                                    labelId="mailing_town_type_id"
                                    label={t('mailing_town_type_id')}
                                    name="mailing_town_type_id"
                                    value={state.mailing_town_type_id}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="0">{t('not_selected')}</MenuItem>
                                    {mailingTownType.map(townType => {
                                        return (
                                            <MenuItem key={townType.id} value={Number(townType.id)}>
                                                {currentLang === 'en' ? townType.value_en : townType.value}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                name="mailing_address"
                                scheme={{
                                    helper_text: t('address_example'),
                                    label: t('mailing_address'),
                                    required: true,
                                    type: {
                                        format: 'address',
                                    },
                                }}
                                defaultValue={profileBasic.mailing_address ? profileBasic.mailing_address : ''}
                                refs={refs} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.diplomaBlock}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="caption" className={classes.diplomaLabel}>
                                {t('diploma_id')}
                                &nbsp;
                                <span className="MuiFormLabel-asterisk">*</span>
                            </Typography>
                        </Grid>
                        <input type="hidden" ref={input => refs.diploma_id = input} value={state.diploma_id}/>
                        <FormControl component="fieldset" size="small" required>
                            <RadioGroup
                                aria-label="diploma"
                                name="diploma_id"
                                value={state.diploma_id}
                                onChange={handleChange}>
                                {Object.keys(configDiploma).map(diplomaId => {
                                    return (
                                        <FormControlLabel key={diplomaId} value={Number(diplomaId)}
                                                          control={<Radio color="primary"/>}
                                                          label={currentLang === 'en' ?
                                                              configDiplomaEn[diplomaId] : configDiploma[diplomaId]}/>
                                    );
                                })}
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={t('custom_information')}
                        inputRef={input => refs.custom_information = input}
                        defaultValue={profileBasic.custom_information ? profileBasic.custom_information : ''}
                        helperText={t('helper_additional_info')}/>
                </Grid>

                <Grid item xs={12}>
                    <BasicFormFilePhotoContainer
                        photoFileId={profileBasic.photo_file_id ? profileBasic.photo_file_id : 0}
                        getPhotoFileIds={(f) => refs.getPhotoFileIdsFn = f}
                        successSaveCallback={(f) => refs.successSaveCallbackForFiles = f}
                        scanCopySnilsFileId={profileBasic.scan_copy_snils_file_id ? profileBasic.scan_copy_snils_file_id : 0}
                        digitalProfileSettings={digitalProfileSettings} />
                </Grid>

                <Grid item xs={12} className={classes.alignRight}>
                    <Button variant="contained" color="primary" onClick={save}>
                        {t('save')}
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};
export default BasicForm;